module.exports = __webpack_public_path__ + "img/古灵男.65d703fe.png";